const MeetingViewer = ({ src, matches  }) => {

  return (
    <iframe
      title="Meeting Viewer"
      src={src}
      style={{ width: matches ? "" : "100%", height: matches ? "85%" : "90%" }}
      sandbox="allow-same-origin allow-scripts allow-forms"
    ></iframe>
 );
};

export default MeetingViewer;
